(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  // Add this to your header.js file
  class SearchToggle {
    constructor() {
      this.searchButton = document.querySelector('search-button');
      this.searchContainer = document.querySelector('.header__search');
      this.searchCloseButton = document.querySelector('.header__search-close');
      this.searchInput = this.searchContainer?.querySelector('input[type="search"]');
      this.predictiveSearch = document.querySelector('predictive-search');
      this.isOpen = false;

      this.init();
    }

    init() {
      if (!this.searchButton || !this.searchContainer) return;

      // Bind events
      this.bindEvents();
    }

    bindEvents() {
      // Search button click
      this.searchButton.addEventListener('click', (e) => {
        e.preventDefault();
        // Only work on mobile
        if (window.innerWidth > 1023) return;

        this.toggleSearch();
      });

      // Close button click
      if (this.searchCloseButton) {
        this.searchCloseButton.addEventListener('click', (e) => {
          e.preventDefault();
          this.closeSearch();
        });
      }

      // Escape key to close
      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && this.isOpen) {
          this.closeSearch();
        }
      });

      // Close on window resize to desktop
      window.addEventListener('resize', () => {
        if (window.innerWidth > 1023 && this.isOpen) {
          this.closeSearch();
        }
      });

      // Click outside to close
      document.addEventListener('click', (e) => {
        if (this.isOpen && !this.searchContainer.contains(e.target) && !this.searchButton.contains(e.target)) {
          this.closeSearch();
        }
      });

      // Prevent search container clicks from closing
      this.searchContainer.addEventListener('click', (e) => {
        e.stopPropagation();
      });
    }

    toggleSearch() {
      if (this.isOpen) {
        this.closeSearch();
      } else {
        this.openSearch();
      }
    }

    openSearch() {
      // Only work on mobile
      if (window.innerWidth > 1023) return;

      this.isOpen = true;

      // Add classes for animation
      this.searchContainer.classList.add('search-active');
      this.searchButton.classList.add('active');

      // Focus the search input to trigger predictive search
      setTimeout(() => {
        if (this.searchInput) {
          this.searchInput.focus();

          // Trigger focus event to open predictive search
          this.searchInput.dispatchEvent(new Event('focus', { bubbles: true }));
        }
      }, 300);

      // Prevent body scroll on mobile
      document.body.style.overflow = 'hidden';
    }

    closeSearch() {
      this.isOpen = false;

      // Remove classes for animation
      this.searchContainer.classList.remove('search-active');
      this.searchButton.classList.remove('active');

      // Blur input and close predictive search
      if (this.searchInput) {
        this.searchInput.blur();
      }

      // Close predictive search more safely
      if (this.predictiveSearch) {
        try {
          // Remove predictive search classes
          this.predictiveSearch.classList.remove('predictive-search-open');
          document.body.classList.remove('search-open');

          // Hide search content if it exists
          const searchContent = this.predictiveSearch.querySelector('.search__content');
          if (searchContent) {
            searchContent.classList.add('hidden');
          }
        } catch (error) {
          console.log('Error closing predictive search:', error);
        }
      }

      // Restore body scroll
      document.body.style.overflow = '';
    }
  }

  // Initialize when DOM is loaded
  document.addEventListener('DOMContentLoaded', () => {
    new SearchToggle();
  });

  // Also handle if this script loads after DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      new SearchToggle();
    });
  } else {
    new SearchToggle();
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["reece-product-collection"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const roots = document.querySelectorAll('[data-ra-pc]');
    roots.forEach(init);

    function init(root) {
      const track   = root.querySelector('[data-ra-pc-track]');
      const prevBtn = root.querySelector('[data-ra-pc-prev]');
      const nextBtn = root.querySelector('[data-ra-pc-next]');
      const progress= root.querySelector('[data-ra-pc-progress]');
      const live    = root.querySelector('[data-ra-pc-live]');
      if (!track) return;

      const perView = () => parseInt(getComputedStyle(root).getPropertyValue('--per-view'), 10) || 1;
      const slides  = Array.from(track.children);

      function pageCount() { return Math.max(1, Math.ceil(slides.length / perView())); }
      function currentPage() {
        const slideW = slides[0].getBoundingClientRect().width + 16;
        return Math.round(track.scrollLeft / (slideW * perView()));
      }

      function buildProgress() {
        progress.innerHTML = '';
        const thumb = document.createElement('span');
        thumb.className = 'ra-pc__progress-thumb';
        progress.appendChild(thumb);
        update();
      }

      function goTo(page) {
        const slideW = slides[0].getBoundingClientRect().width + 16;
        track.scrollTo({ left: page * slideW * perView(), behavior: 'smooth' });
      }

      function update() {
        const page = currentPage();
        const total = pageCount();
        const thumb = progress.firstElementChild;
        if (thumb) {
          const inset = 2;
          const usable = Math.max(0, progress.clientWidth - inset * 2);
          const sw = track.scrollWidth;
          const cw = track.clientWidth;
          const visible = sw > 0 ? cw / sw : 1;
          const thumbW = Math.min(usable, Math.max(24, visible * usable));
          const maxScroll = sw - cw;
          const pos = maxScroll > 0 ? track.scrollLeft / maxScroll : 0;
          thumb.style.width = thumbW + 'px';
          thumb.style.left = (inset + pos * (usable - thumbW)) + 'px';
        }
        prevBtn.disabled = page <= 0;
        nextBtn.disabled = page >= total - 1;
        if (live) live.textContent = 'Slide ' + (page + 1) + ' of ' + total;
      }

      prevBtn.addEventListener('click', () => goTo(Math.max(0, currentPage() - 1)));
      nextBtn.addEventListener('click', () => goTo(Math.min(pageCount() - 1, currentPage() + 1)));
      progress.addEventListener('click', (e) => {
        const rect = progress.getBoundingClientRect();
        const max = track.scrollWidth - track.clientWidth;
        if (max <= 0) return;
        const frac = Math.min(1, Math.max(0, (e.clientX - rect.left) / rect.width));
        track.scrollTo({ left: frac * max, behavior: 'smooth' });
      });
      let rafPending = false;
      track.addEventListener('scroll', () => {
        if (rafPending) return;
        rafPending = true;
        requestAnimationFrame(() => { rafPending = false; update(); });
      }, { passive: true });
      window.addEventListener('resize', debounce(() => { buildProgress(); }, 150));
      root.addEventListener('keydown', e => {
        if (e.key === 'ArrowLeft')  { e.preventDefault(); goTo(Math.max(0, currentPage() - 1)); }
        if (e.key === 'ArrowRight') { e.preventDefault(); goTo(Math.min(pageCount() - 1, currentPage() + 1)); }
      });

      // Add to cart
      root.querySelectorAll('[data-ra-pc-atc]').forEach(btn => {
        btn.addEventListener('click', async (e) => {
          e.preventDefault();
          const id  = btn.dataset.variantId;
          const url = btn.dataset.productUrl;
          if (!id) { window.location.href = url; return; }
          btn.setAttribute('aria-busy', 'true');
          try {
            const res = await fetch('/cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
              body: JSON.stringify({ items: [{ id: Number(id), quantity: 1 }] })
            });
            if (!res.ok) throw new Error('add failed');
            // Refresh + open the theme cart drawer. This theme exposes its drawer as `CartDrawer`.
            document.dispatchEvent(new CustomEvent('cart:refresh'));

            // Candidate handles, in priority order:
            // 1) an element id="CartDrawer" / class .CartDrawer (this theme), or a Dawn-style component
            const drawer = document.querySelector('#CartDrawer, .CartDrawer, cart-drawer, [data-cart-drawer]');
            // 2) a global controller object literally named CartDrawer (some themes expose one)
            const ctrl = (typeof window.CartDrawer === 'object') ? window.CartDrawer : null;
            // 3) a toggle the theme already wires up to open the cart
            const toggle = document.querySelector('[data-drawer-toggle="CartDrawer"], [aria-controls="CartDrawer"], .js-drawer-open-cart, .js-drawer-open-cart-trigger');

            if (drawer && typeof drawer.open === 'function') drawer.open();
            else if (ctrl && typeof ctrl.open === 'function') ctrl.open();
            else if (toggle) toggle.click();
            else if (drawer) drawer.dispatchEvent(new CustomEvent('open'));
            else window.location.href = '/cart';
          } catch (err) {
            window.location.href = url;
          } finally {
            btn.removeAttribute('aria-busy');
          }
        });
      });

      buildProgress();
    }

    function throttle(fn, ms) {
      let last = 0, t;
      return (...a) => {
        const now = Date.now();
        const wait = ms - (now - last);
        if (wait <= 0) { last = now; fn(...a); }
        else { clearTimeout(t); t = setTimeout(() => { last = Date.now(); fn(...a); }, wait); }
      };
    }
    function debounce(fn, ms) {
      let t;
      return (...a) => { clearTimeout(t); t = setTimeout(() => fn(...a), ms); };
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
